'use client';
import { Button, Input, message, Spin, Upload, UploadFile } from 'antd';
import styles from './customInput.module.scss';
import { AttachmentType, TicketMessageType, TicketStatusEnum, TicketType } from 'types';
import { useRef, useState } from 'react';
import { COLORS } from 'utilities';
import { ExtendedUploadRef } from './customInput.type';
import { CgAttachment } from 'react-icons/cg';
import { BiSend } from 'react-icons/bi';
import { RestAPI, useRealTimeState } from 'scripts';
import { API } from 'data';

function CustomInputComp(props: { ticket?: TicketType; onSubmit: (e: TicketMessageType) => void }) {
    const uploadRef = useRef<ExtendedUploadRef>(null);
    const fileLists = useRealTimeState<Array<UploadFile>>([]);
    const files = useRealTimeState<AttachmentType[]>([]);
    const [messageValue, setMessageValue] = useState('');
    const [loading, setLoading] = useState(false);

    const handleButtonClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        uploadRef.current?.upload?.uploader?.onClick(e);
    };

    function submitMessage() {
        setLoading(true);
        RestAPI.post<TicketMessageType>(API.ticket.sendMessage, {
            file: files.get().map((i) => i.id),
            status: TicketStatusEnum.pending,
            ticket: props.ticket?.id,
            text: messageValue,
        })
            .then((res) => {
                props.onSubmit(res.data);
                setLoading(false);
                setMessageValue('');
                fileLists.set([]);
                files.set([]);
            })
            .catch(() => {
                message.error('خطایی رخ داده است. مجددا تلاش نمایید');
                setLoading(false);
            });
    }
    const onUpload = (f: File) => {
        const list = [...fileLists.get()];
        const uid = `-${list.length + 1}`;
        list.push({
            uid,
            percent: 0,
            name: f.name,
            status: 'uploading',
        });
        fileLists.set(list);
        const body = new FormData();
        body.append('file', f);
        body.append('alt', f.name);
        RestAPI.form<AttachmentType>(API.core.attachment.index, body)
            .then((res) => {
                const newList = fileLists.get();
                const index = newList.findIndex((i) => i.uid === uid);
                if (index >= 0)
                    newList[index] = {
                        uid: res.data.id.toString(),
                        percent: 100,
                        name: f.name,
                        status: 'done',
                        url: res.data.file,
                    };
                files.set([...files.get(), res.data]);
                fileLists.set(newList);
            })
            .catch(() => {
                const newList = [...fileLists.get()];
                const index = newList.findIndex((i) => i.uid === uid);
                if (index >= 0)
                    newList[index] = {
                        uid: f.name,
                        name: f.name,
                        status: 'error',
                    };
                fileLists.set(newList);
            });
    };

    return (
        <div className={`${styles['input-layout']}`}>
            <Upload
                ref={uploadRef}
                className={`${fileLists.dep.length ? styles['active'] : ''}`}
                fileList={fileLists.dep}
                showUploadList={{
                    showPreviewIcon: true,
                }}
                multiple={true}
                onPreview={(file: UploadFile) => window.open(file.url, '_blank')}
                customRequest={(e) => {
                    const temp: any = e;
                    const file: File = temp.file;
                    onUpload(file);
                }}
            />
            <Input
                value={messageValue}
                className={`${styles['input']}`}
                placeholder="پیامی بنویسید..."
                prefix={
                    <>
                        {loading ? (
                            <Spin size="small" />
                        ) : (
                            <BiSend color={COLORS.primary} size={20} className={`pointer`} onClick={submitMessage} />
                        )}
                    </>
                }
                addonAfter={
                    <Button
                        onClick={handleButtonClick}
                        type="text"
                        icon={<CgAttachment size={20} color={COLORS.gray1} />}
                    />
                }
                onChange={(e) => setMessageValue(e.target.value)}
            />
        </div>
    );
}

export default CustomInputComp;
